/**
 * @fileOverview 知识库
 * @author
 */
import actions from './actions';
import { combineReducers } from 'redux';

const knowledge = (state = {}, action) => {
  let data = null;
  let key = '';

  data = {};

  for (key in state) {
    if (state[key]) {
      data[key] = state[key];
    }
  }

  // cgi相关的都放到response下面了
  switch (action.type) {
    case actions.knowledgeTypes.info:
    case actions.knowledgeTypes.list:
    case actions.knowledgeTypes.search:
    case actions.knowledgeTypes.catalogList:
    case actions.knowledgeTypes.catalogId:
      data[action.type] = action.response || {};
      return data;
  }

  return state;
};

const reducers = combineReducers({
  knowledge,
});

export default reducers;
